/**
 * Created by optimistex on 23.06.17.
 */

export interface IMenuBadge {
    count: number;
    ariaLabel: string;
    className?: string;
}

export interface IMenuItem {
    label: string;
    state?: string;
    weight?: number;
    permissions?: string | string[];
    roles?: string | string[];
    items?: IMenu;
    svgIcon?: string;   // only for root items
    canShow?: () => boolean;
    badge?: () => IMenuBadge | null;
}

export interface IMenu {
    [itemId: string]: IMenuItem;
}

export interface IMenuRawData {
    [userGroup: string]: IMenu;
}

export interface IMenuItemIndexed extends Omit<IMenuItem, 'items'> {
    id: string;
    isActive: boolean;
    items?: IMenuItemIndexed[];
}

export class CMenuData {
    public items: IMenuItemIndexed[] = [];
    public itemsByLevel: IMenuItemIndexed[] = [];
    public isActive = false;
}
